export default __webpack_public_path__ + "static/media/misc-closetB-1024w.2b0782bb.webp";